<!-- Overlay container - centered and on top of all elements -->
<div class="wpx-qrcode-overlay">
  <div class="wpx-qrcode-modal">
    <div class="wpx-qrcode-content">
      <div class="wpx-qrcode-container">
        <qrcode
          [qrdata]="qrCodeUrl"
          [width]="size"
          [errorCorrectionLevel]="'M'"
        ></qrcode>
      </div>

      <!-- Close button -->
      <button
        class="wpx-qrcode-close"
        id="cwpx-qrcode-close-bttn"
        type="button"
        aria-label="Close QR Code"
        (click)="close.emit()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
</div>

<!-- Hidden input for QA testing - contains the QR code URL -->
<input
  type="hidden"
  id="wpx-qrcode-hidden-input"
  [value]="qrCodeUrl"
  data-testid="wpx-qrcode-url"
  aria-label="WPX QR Code URL"
/>
